/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.com/docs/reference/config-files/gatsby-browser/
 */

import './src/styles/css/bootstrap.min.css';
import "./src/styles/css/animate.min.css"
import "./src/styles/css/boxicons.min.css"
import "./src/styles/css/flaticon.css"
import 'react-accessible-accordion/dist/fancy-example.css'
import 'react-18-image-lightbox/style.css';
import "/node_modules/aos/dist/aos.css";
import "swiper/css"
import "swiper/css/bundle"

// Global style
import "./src/styles/css/style.css" 
import "./src/styles/css/responsive.css" 
import "./src/styles/css/cookie-banner.css"
import "./src/styles/css/contact-form-enhanced.css"

// If you want RTL style comment out the below rtl.css
// import "./src/styles/css/rtl.css"

import {
  DEFAULT_LANGUAGE,
  detectSiteLanguage,
  getExplicitSiteLanguage,
  setStoredSiteLanguage,
} from "./src/utils/detectSiteLanguage"

const isSpanishPath = pathname =>
  pathname === "/es" || pathname === "/es/" || pathname.startsWith("/es/")

const stripSpanishPrefix = pathname => {
  if (pathname === "/es" || pathname === "/es/") {
    return "/"
  }
  if (pathname.startsWith("/es/")) {
    return pathname.slice(3) || "/"
  }
  return pathname
}

/**
 * Preselect from the browser's primary language (`navigator.language`):
 * Spanish → /es, otherwise English routes.
 * Manual switcher choice (explicit localStorage) wins when present.
 *
 * Use location.replace only — window.___replace in onClientEntry breaks
 * Gatsby StaticQuery hydration and can leave a blank page.
 */
export const onClientEntry = () => {
  if (typeof window === "undefined") {
    return
  }

  const { pathname, search, hash } = window.location
  const preferred =
    getExplicitSiteLanguage() || detectSiteLanguage() || DEFAULT_LANGUAGE

  setStoredSiteLanguage(preferred)

  if (isSpanishPath(pathname)) {
    if (preferred === "es") {
      return
    }
    window.location.replace(`${stripSpanishPrefix(pathname)}${search}${hash}`)
    return
  }

  if (preferred !== "es") {
    return
  }

  const targetPath =
    pathname === "/" ? `/es/${search}${hash}` : `/es${pathname}${search}${hash}`

  window.location.replace(targetPath)
}
